import HelpIcon from "@mui/icons-material/Help"
import { Box, Divider, List, ListItem, Rating, Typography } from "@mui/material"

export const EvaluationCompetency = ({ questions = [], questionRating, noComment }) => {
	if (questions.length === 0)
		return (
			<Box sx={{ textAlign: "center", p: 2 }}>
				<Typography color="textSecondary" variant="h6">
					No hay preguntas disponibles a
				</Typography>
			</Box>
		)

	return (
		<List sx={{ width: "100%", p: 2 }}>
			{questions.map((question, idx) => (
				<Question
					key={question.id}
					{...{
						question,
						...questionRating(question.id),
					}}
				/>
			))}
		</List>
	)
}

const Question = ({ question, rating, setRating }) => {
	return (
		<Box key={question.id}>
			<ListItem
				disablePadding
				sx={{
					display: "flex",
					alignItems: "flex-start",
					justifyContent: "space-between",
					// p: 2,
					flexDirection: "column",
					transition: "all 0.2s ease-in-out",
				}}
			>
				<Typography
					variant="body1"
					sx={{
						fontWeight: 600,
						color: "#333",
						// mb: 2,
						width: "100%",
					}}
				>
					{question.question}
				</Typography>

				{question.auxiliary && (
					<Box
						sx={{
							display: "flex",
							alignItems: "flex-start",
							gap: 1,
							p: 1.5,
							// bgcolor: "#f0f4ff",
							borderRadius: 1,
							// borderLeft: "3px solid #667eea",
							// mb: 2,
							width: "100%",
						}}
					>
						<HelpIcon
							sx={{
								fontSize: "1.2rem",
								// color: "#667eea",
								mt: 0.3,
								flexShrink: 0,
							}}
						/>
						<Typography
							variant="body2"
							sx={{
								color: "#555",
								fontStyle: "italic",
								lineHeight: 1.5,
							}}
						>
							{question.auxiliary}
						</Typography>
					</Box>
				)}

				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						gap: 0.5,
						width: "100%",
					}}
				>
					<Rating
						value={rating}
						onChange={(e, newValue) => {
							setRating(newValue)
						}}
						// readOnly
						size="medium"
						sx={{
							color: "#ffc107",
							"& .MuiRating-iconFilled": {
								color: "#ffc107",
							},
						}}
					/>
				</Box>
			</ListItem>
		</Box>
	)
}
